import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Wallet, TrendingUp } from "lucide-react";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Panel, PageHead, StatCard, Empty } from "@/components/common";
import { useApi, inr, fmtDate } from "@/lib/api";

const TYPE_LABEL = { direct_referral: "Direct referral bonus", level_2: "Level 2 bonus", level_3: "Level 3 bonus", topup: "Wallet top-up", admin_credit: "Added by admin", admin_debit: "Deducted by admin", purchase: "Product purchase", refund: "Order refund", daily_return: "Daily income" };

export default function Earnings() {
  const api = useApi();
  const { me } = useOutletContext();
  const [rows, setRows] = useState(null);
  useEffect(() => { api("get", "/me/transactions").then(setRows); }, [api]);
  return (
    <div data-testid="earnings-page">
      <PageHead label="Wallet" title="Earnings" />
      <div className="mb-6 grid gap-4 sm:grid-cols-2 sm:gap-6">
        <StatCard label="Wallet balance" value={inr(me.user.wallet)} icon={Wallet} testId="earnings-wallet" />
        <StatCard label="Lifetime earned" value={inr(me.user.total_earned)} icon={TrendingUp} accent="text-amber-400" testId="earnings-total" />
      </div>
      <Panel>
        {!rows ? <p className="text-sm text-slate-500">Loading…</p> : rows.length === 0 ? <Empty testId="earnings-empty" text="No earnings yet. You earn a bonus each time a member you referred gets activated." /> : (
          <Table data-testid="earnings-table">
            <TableHeader><TableRow><TableHead>Txn ID</TableHead><TableHead>Date</TableHead><TableHead>Type</TableHead><TableHead>From</TableHead><TableHead className="text-right">Amount</TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.map((t) => (
                <TableRow key={t.id} data-testid={`earning-row-${t.id}`}>
                  <TableCell className="font-mono text-xs text-slate-500">{t.id.slice(0, 8)}</TableCell>
                  <TableCell className="text-xs">{fmtDate(t.created_at)}</TableCell>
                  <TableCell>{TYPE_LABEL[t.type] || t.type}</TableCell>
                  <TableCell className="text-white">{t.source_name}{(t.type.startsWith("admin_") || ["purchase", "refund", "daily_return"].includes(t.type)) && <p className="text-xs text-slate-500">{t.note}</p>}</TableCell>
                  <TableCell className={`text-right font-mono ${t.amount < 0 ? "text-red-400" : "text-emerald-400"}`}>{t.amount < 0 ? `−${inr(-t.amount)}` : `+${inr(t.amount)}`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Panel>
    </div>
  );
}
